/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:47:30
 * @LastEditors: sj
 * @LastEditTime: 2022-05-19 10:35:48
 */
import { unwrapResult } from '@reduxjs/toolkit'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { List } from '../../../models/page'
import { ProvincePageParams } from '../../../services/insurance'
import { ThemeContext } from '../../../theme/ThemeContext'
import { selectInsuranceArray } from '../../tenant/setting/TenentSettingSlice'
import { ProvinceColumns } from '../Columns'
import { ProvincePageValue, getProvincePage } from '../InsuranceSlice'
import { CurrentQuery } from './CurrentQuery'
import styles from './province.module.css'

export const ProvinceCatalog = () => {
  const theme = useContext(ThemeContext)
  const dispatch = useDispatch<RootDispatch>()

  const insuranceArray = useSelector(selectInsuranceArray)

  const [data, setData] = useState<List<ProvincePageValue>>()

  const [queries, setQueries] = useState<ProvincePageParams>({
    size: 10,
    current: 1,
  })

  useEffect(() => {
    if (insuranceArray && insuranceArray.length !== 0) {
      getData()
    }
    console.log(queries, insuranceArray)
  }, [queries, insuranceArray])

  const getData = () => {
    dispatch(
      getProvincePage({
        insuranceCode: insuranceArray[0].insuranceCode,
        ...queries,
        hilistName: queries.name,
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setData(res)
      })
  }

  return (
    <div className={styles.content}>
      <CurrentQuery
        code={1312}
        onValueChange={(vs) => {
          setQueries({ ...queries, ...vs })
        }}
      />
      <EditableList
        style={{ color: theme.tc3 }}
        className={styles.table}
        columns={ProvinceColumns((id) => {
          console.log(id)
        }, queries.size * (queries.current - 1))}
        page={{
          size: queries.size,
          current: queries.current || 1,
          total: data?.total || 0,
          items: data?.records || [],
        }}
        onChangePage={(current, size?: number) => {
          setQueries({
            ...queries,
            current,
            size: size || 10
          })
        }}
      />
    </div>
  )
}
